import { ThemeOverride } from "@chakra-ui/react";
import { mode } from "@chakra-ui/theme-tools";

/**
 * Overrides for global styles
 */
export const styles = {
  global(props) {
    return {
      html: {
        overflowY: "scroll",
        overflowX: "hidden",
        height: "auto",
      },
      body: {
        margin: 0,
        minHeight: "100vh",
        bg: mode("neutral.white", "slate.850")(props),
        color: mode("neutral.black", "neutral.white")(props),
        fontFamily: "Roboto",
      },
      "#root": {
        minHeight: "100dvh",
        display: "flex",
        flexDirection: "column",
      },
    };
  },
} as ThemeOverride["styles"];
